import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["inviteCode", "inviteCodeSwitch", "title", "titleGroup", "titleError"]

  connect() {
    this.updateTitles()
    this.updateInviteCode(false)
  }

  selectTitle() {
    this.updateTitles()
    this.clearTitleError()
  }

  showTitleError(event) {
    event.preventDefault()
    this.titleGroupTarget.classList.add("error")
    this.titleErrorTarget.hidden = false
    this.setTitleAriaInvalid(true)
  }

  clearFieldError(event) {
    const errorWrapper = event.target.closest(".field_with_errors")

    if (errorWrapper) {
      errorWrapper.replaceWith(...errorWrapper.childNodes)
    }
  }

  toggleInviteCode() {
    this.updateInviteCode(true)
  }

  updateTitles() {
    this.titleTargets.forEach((label) => {
      const selected = label.querySelector('input[type="radio"]').checked

      label.classList.toggle("btn-success", selected)
      label.classList.toggle("btn-light", !selected)
    })
  }

  clearTitleError() {
    this.titleGroupTarget.classList.remove("error")
    this.titleErrorTarget.hidden = true
    this.setTitleAriaInvalid(false)
  }

  setTitleAriaInvalid(invalid) {
    this.titleTargets.forEach((label) => {
      label.querySelector('input[type="radio"]').setAttribute("aria-invalid", invalid.toString())
    })
  }

  updateInviteCode(focus) {
    const visible = this.inviteCodeSwitchTarget.checked

    this.inviteCodeTarget.classList.toggle("is-hidden", !visible)
    this.inviteCodeTarget.required = visible

    if (visible && focus) {
      this.inviteCodeTarget.focus()
    } else if (!visible) {
      this.inviteCodeTarget.value = ""
    }
  }
}
